module.exports = __webpack_public_path__ + "img/dis-total.929dea5e.svg";